module.exports = __webpack_public_path__ + "static/media/francisco-slate.15502948.svg";